"use client";
import {useState} from "react";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import {Button} from "@/components/ui/button";
import * as yup from "yup";
import {Form} from "@/components/ui/form";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import CWFTextarea from "@/components/ui/CWFTextarea";
import CWFButton from "@/components/ui/CWFButton";
import CWFSelect from "@/components/ui/CWFSelect";
import {ReviewsRate} from "@/json/reviewsRate";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import toast from "react-hot-toast";
import {useRouter} from "next/navigation";


const REQUIRED_ERROR = "Ce champs est requis";

const formReviewSchema = yup.object({
    content : yup.string().required(REQUIRED_ERROR),
    rates : yup.number().required(),
})

export default function ReviewDialog({activityId, ownerUser, userId}){
    const axios = useAxiosAuth();
    const router = useRouter();
    const [reviewOpen, setReviewOpen] = useState(false);

    const formReview = useForm({
        resolver: yupResolver(formReviewSchema)
    });

    function addReview(data){
        axios.post(`reviews/${activityId}`,data)
            .then(() => toast.success('Votre avis a bien été pris en compte.'))
            .catch(() => toast.error('Une erreur est survenue'))
            .finally(() => {
               setReviewOpen(false);
               router.refresh();
            })
    }

    if(ownerUser === userId){
        return <></>
    }
    return(
        <>
            <Button onClick={() => setReviewOpen(true)}>
                Donner mon avis
            </Button>
            <CWFResponsiveDialog
                trigger={null}
                title={<p>Donner votre avis</p>}
                open={reviewOpen}
                onOpenChange={setReviewOpen}
            >
                <Form {...formReview}>
                    <form onSubmit={formReview.handleSubmit(addReview)} className={"grid gap-4"}>
                        <CWFSelect control={formReview.control} name={"rates"} items={ReviewsRate} label={'Note sur 5'}/>
                        <CWFTextarea name={"content"} control={formReview.control} label={"Message"}/>
                        <div className={"flex justify-center"}>
                            <CWFButton>Donner mon avis</CWFButton>
                        </div>
                    </form>
                </Form>

            </CWFResponsiveDialog>
        </>

    )
}